export type OrderingCapabilityField =
  | "orderingEnabled"
  | "deliveryEnabled"
  | "cashOnDeliveryEnabled";

export type OrderingCapabilityState = {
  orderingEnabled: boolean;
  deliveryEnabled: boolean;
  cashOnDeliveryEnabled: boolean;
};

export type OrderingCapabilityPatch = {
  orderingEnabled?: boolean;
  deliveryEnabled?: boolean;
  cashOnDeliveryEnabled?: boolean;
};

export type OrderingPatchResult = {
  patchBody: OrderingCapabilityPatch;
  isCascade: boolean;
};

export function buildOrderingPatch(
  _currentState: OrderingCapabilityState,
  changedField: OrderingCapabilityField,
  nextValue: boolean,
): OrderingPatchResult {
  if (changedField === "orderingEnabled" && !nextValue) {
    return {
      patchBody: {
        orderingEnabled: false,
        deliveryEnabled: false,
        cashOnDeliveryEnabled: false,
      },
      isCascade: true,
    };
  }

  if (changedField === "deliveryEnabled" && !nextValue) {
    return {
      patchBody: {
        deliveryEnabled: false,
        cashOnDeliveryEnabled: false,
      },
      isCascade: true,
    };
  }

  return {
    patchBody: { [changedField]: nextValue } as OrderingCapabilityPatch,
    isCascade: false,
  };
}
